import React from 'react'

import { InsufficientPermissions, PaginatedTable } from '../../common'
import { getAuthUser } from '../../../helpers'
import defineAbilityFor from '../defineAbility'
import { JsonSupplier, Supplier } from '../../../models'
import { getRecoverySuppliers } from '../../../api'
import { Link } from 'react-router-dom'

export const RecoveryLanding = () => {
    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('View', 'RecoverySuppliers')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<Supplier, JsonSupplier>
            title="Recovery Suppliers"
            getData={ getRecoverySuppliers }
            modelConstructor={(json) => new Supplier(json)}
            searchPlaceholder="Search by supplier name"
            Table={(suppliers) => (
                <table className="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Street</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Zip</th>
                            <th>Country</th>
                        </tr>
                    </thead>
                    <tbody>
                        {suppliers.map((supplier) => (
                            <tr key={supplier.id}>
                                <td><Link to={ `/suppliers/${supplier.id}` }>{ supplier.name }</Link></td>
                                <td>{ supplier.primaryPhone }</td>
                                <td>{ supplier.physicalAddress.street }</td>
                                <td>{ supplier.physicalAddress.city }</td>
                                <td>{ supplier.physicalAddress.state?.name}</td>
                                <td>{ supplier.physicalAddress.zip }</td>
                                <td>{ supplier.physicalAddress.country?.name }</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        />
    )
}
